import dayjs, { guessTimezone } from "@/lib/helpers/dayjs";

import type {
  ConsentResponse,
  PolicyAcknowledgementDTO,
  PolicyConsentDTO,
  UUID,
} from "@/core/types";
import { getUsernameFromToken } from "@/redux/actions/auth";

type CreateAcknowledgementProps = {
  consentResponse: ConsentResponse;
  isGivenOnBehalf?: boolean;
  policyVersion?: string;
};

export function createAcknowledgementPayload({
  consentResponse,
  isGivenOnBehalf,
}: CreateAcknowledgementProps): PolicyAcknowledgementDTO {
  const userName = getUsernameFromToken();

  return {
    acknowledged_by: userName || "self",
    client: "web",
    consent_response: consentResponse,
    date: dayjs.utc().toISOString(),
    timezone: guessTimezone(),
    ...(isGivenOnBehalf && { consent_given_by: userName }),
  };
}

type CreateVersionedAcknowledgementProps = {
  consentResponse: ConsentResponse;
  consentGivenBy?: UUID;
  policyVersion?: string;
};

export function createVersionedAcknowledgementPayload({
  consentResponse,
  policyVersion,
  consentGivenBy,
}: CreateVersionedAcknowledgementProps): PolicyConsentDTO {
  const userName = getUsernameFromToken();

  return {
    acknowledged_by: userName || "self",
    client: "web",
    consent_response: consentResponse,
    date: dayjs.utc().toISOString(),
    timezone: guessTimezone(),
    version: policyVersion,
    /* If CSE is opting-out the patient - we want to override the consent_given_by with the patientId */
    consent_given_by: consentGivenBy || userName,
  };
}
